export const API_BURGERS: string = 'https://norma.nomoreparties.space/api'
